/**
 * Custom JavaScript
 * =================
 * Semua custom JS ditaruh di sini
 * 
 * File ini akan di-copy ke themes/development/assets/ saat deployment
 */

(function() {
  'use strict';

  // Wait for DOM ready
  document.addEventListener('DOMContentLoaded', function() {
    console.log('Custom scripts loaded');
    
    // Initialize all custom features
    initCustomFeatures();
  });

  function initCustomFeatures() {
    openExternalLinksInNewTab();
  }

  /* ===========================================
     Custom Feature: External Links
     =========================================== */

  function openExternalLinksInNewTab() {
    const links = document.links;

    for (let i = 0, linksLength = links.length; i < linksLength; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
      }
    }
  }

  /* ===========================================
     Utility Functions
     =========================================== */
  
  // Debounce function
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Format currency (adjust untuk currency Indonesia jika perlu)
  function formatMoney(cents, format) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, format);
    }
    return (cents / 100).toLocaleString('id-ID', {
      style: 'currency',
      currency: 'IDR'
    });
  }

})();
